module.exports = __webpack_public_path__ + "images/85591b008af0283390b3d7617ff6c639-Roboto-BlackItalic.svg";